import React, { useState } from 'react';

import { FormikHelpers } from 'formik';

import { Container, InputArea, Input, Arrows, Label } from './styles';

export interface RenderProps {
  show: boolean;
  value: any;
  onClose: () => void;
  onChange: (value: any) => void;
  testId?: string;
}

interface Props {
  name?: string;
  value?: any;
  placeHolder?: string;
  icon?: JSX.Element;
  noIcon?: boolean;
  error?: string;
  disabled?: boolean;
  label?: string;
  selectRef?: React.RefObject<HTMLDivElement>;
  children: (renderProps: RenderProps) => JSX.Element;
  onChange?: (value: any) => void;
  afterOnChange?: (value: any, value2: any) => void;
  onSetValue?: (value: any) => string;
  onSetFieldValue?: (value: any) => any;
  formik?: FormikHelpers<string>;
  testId?: string;
}

const CustomSelect = ({
  name,
  value,
  placeHolder,
  icon,
  error,
  disabled,
  children,
  onChange,
  afterOnChange,
  onSetValue,
  onSetFieldValue,
  noIcon,
  formik,
  selectRef,
  label,
  testId,
}: Props) => {
  const [showOptions, setShowOptions] = useState(false);
  const newValue = value?.name !== (null || undefined) ? value.name : value;

  const handleClick = () => {
    if (!disabled) {
      setShowOptions(!showOptions);
    }
  };

  const handleOptionsClose = () => {
    if (showOptions) {
      setShowOptions(false);
      if (name && formik) {
        formik.setFieldTouched(name);
      }
    }
  };

  const handleChange = async (newValue: any) => {
    if (name && formik) {
      await formik.setFieldValue(name, onSetFieldValue ? onSetFieldValue(newValue) : newValue);
      formik.setFieldTouched(name);
    } else if (onChange) {
      onChange(newValue);
    }

    if (afterOnChange) {
      afterOnChange('', newValue);
    }
  };

  return (
    <Container ref={selectRef}>
      <InputArea onClick={handleClick}>
        {label && <Label htmlFor={`custom_select_${name}`}>{label}</Label>}
        <Input
          id={`custom_select_${name}`}
          data-testid={testId}
          readOnly
          error={error}
          placeholder={placeHolder}
          value={onSetValue ? onSetValue(value) : newValue}
          disabled={disabled}
        >
          {noIcon ? undefined : icon || <Arrows />}
        </Input>
      </InputArea>
      {children({
        show: showOptions,
        value,
        onClose: handleOptionsClose,
        onChange: handleChange,
        testId,
      })}
    </Container>
  );
};

export default CustomSelect;
